<div class="row">
  <div class="col-9">
    <h5 class="title-header" >Program Parameters</h5>
  </div>
  <div class="flex" style="margin-bottom: 1rem">
    <div class="my-auto">Last Refreshed: {{lastRefreshTime}}</div>
    <mat-slide-toggle [(ngModel)]="refreshEnabled" style="margin-left: 1rem"></mat-slide-toggle>
  </div>
</div>

<app-program-details [program]="program"></app-program-details>

<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header >
    Dispatches in next 24 hours
  </mat-expansion-panel-header>
  <mat-panel-description [ngStyle]="{'width': '100%'}" >
    <app-dispatch-listings [program]="program" [displayHeader]="false" (selectedDispatchEmitter)="setSelectedDispatch($event)" [includeTypes]="['PENDING', 'ACTIVE', 'ERROR']" [dispatchHourTimeWindow]="24"></app-dispatch-listings>
  </mat-panel-description>
</mat-expansion-panel>

<mat-expansion-panel>
  <mat-expansion-panel-header>
    Site Status
  </mat-expansion-panel-header>
  <mat-panel-description>
    <app-account-status *ngIf="selectedDispatch" [program]="program" [programSites]="programSites" [timezone]="timezone" [selectedDispatch]="selectedDispatch" [dispatchHourTimeWindow]="24" [refreshEnabled]="refreshEnabled"></app-account-status>
  </mat-panel-description>
</mat-expansion-panel>

<div class="row" *ngIf="program && program.programType == 'COINCIDENT_PEAK'">
  <div class="col-12">
    <app-range-selector [sites]="programSites" (paramEvent)="onParamChange($event)" ></app-range-selector>
    <app-ga-chart [params]="params" [chartId]="'ga'" [holdUpdates]="holdUpdates" [program]="program" [timezone]="timezone"></app-ga-chart>
  </div>
</div>
<div class="row" *ngIf="program">
  <div  class="col-12">
    <app-demand-profile [program]="program" [timezone]="timezone" [refreshEnabled]="refreshEnabled"></app-demand-profile>
  </div>
</div>

